export enum Forms {
  login = 'login',
  user = 'user',
  profile = 'profile',
  author = 'author',
  serie = 'serie',
  book = 'book',

  // Searches
  authorListFilter = 'authorListFilter',
  serieListFilter = 'serieListFilter',
  bookListFilter = 'bookListFilter',
}

export interface SearchFormValues {
  searchInput: string;
}
